import { Dispatch, Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ResetTable from "src/base/ResetTable";
import CustomizerContext from "../../../_helper/customizer/index";

const TableData = ({
  data,
  columns,
  actions,
  topAction,
  pageHandler,
  onRowClicked,
}: {
  data: any;
  columns: any[];
  actions?: JSX.Element | JSX.Element[];
  topAction?: React.ReactNode | React.ReactNode[];
  pageHandler?: Dispatch<number>;
  onRowClicked?: (row: any) => void;
}) => {
  const [moonlight, setMoonlight] = useState(false);
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          setMoonlight(document.body.classList.contains("dark-only"));
          console.log("Class list changed:", document.body.classList.value);
        }
      });
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("layout_version") === "light") {
      setMoonlight(false);
    } else {
      setMoonlight(true);
    }
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("layout_version")) {
      localStorage.setItem("layout_version", "light");
    }
  }, []);

  return (
    <Fragment>
      <div className={`table-responsive product-table ${!data?.data || data?.data?.length === 0 ? "overflow-hidden" : ""}`}>
        <DataTable
          onRowClicked={onRowClicked}
          subHeaderComponent={topAction}
          customStyles={{
            subHeader: { style: { backgroundColor: "#00000000" } },
            noData: {
              style: { backgroundColor: moonlight ? "#262932" : "#fff" },
            },
          }}
          subHeader={!!topAction}
          noHeader={!!!topAction}
          pagination
          paginationServer
          onChangePage={pageHandler}
          paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          paginationPerPage={data?.per_page}
          paginationTotalRows={data?.total}
          paginationDefaultPage={data?.current_page}
          columns={columns}
          data={data?.data ?? []}
          actions={actions}
          noDataComponent={<ResetTable />}
        />
      </div>
    </Fragment>
  );
};
export default TableData;
